// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Hw-z","smallCardRow":"Iw-z","largeCardRow":"Jw-z","productSearchRow":"Kw-z","curatedRow":"Lw-z"};